import Icon from "@portal/components/atoms/icons";
import { TextResources } from "@portal/assets/text/TextResources";
import Typography from "@portal/components/atoms/v2/typography";

/**
 * Footer for Sparebanken Møre
 * @returns a footer
 */
export const PortalFooterSbm = () => (
  <div className="flex bg-[#01052F] w-full mt-auto text-[#f2f2f2]">
    <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 md:justify-between container mx-auto px-4 py-4">
      <div className="flex flex-col sm:flex-row min-w-2xs">
        <div className="space-y-1 mb-7 sm:mb-0">
          <div>
            <Typography variant="H5">{TextResources.FOOTER_SBM_CONTACT_HEADER}</Typography>
          </div>
          <div>
            <Typography variant="Body">{TextResources.FOOTER_SBM_OPEN_HOURS}</Typography>
          </div>
          <a href="tel:+4770113000">
            <div className="flex items-center mt-1 sm:hidden">
              <div className="flex pr-2">
                <Icon name="phoneIcon" size="xxsmall" />
              </div>
              <Typography variant="Body">{TextResources.FOOTER_SBM_PHONE_NUMBER}</Typography>
            </div>
          </a>
          <div className="hidden sm:flex items-center mt-1">
            <div className="flex pr-2">
              <Icon name="phoneIcon" size="xxsmall" />
            </div>
            <Typography variant="Body">{TextResources.FOOTER_SBM_PHONE_NUMBER}</Typography>
          </div>
        </div>
      </div>
      <div className="flex flex-col max-w-lg">
        <Typography>
          Du er nå logget inn i Norne Securities sin handelsløsning. Alle investeringstjenester som leveres gjennom
          handelsløsningen ytes direkte fra Norne til deg som kunde. Det er Norne som er ansvarlig for investeringstjenestene i
          henhold til Nornes Alminnelige forretningsvilkår.
        </Typography>
      </div>
    </div>
  </div>
);
